import React from 'react'
import { BellIcon, UserCircleIcon } from '@heroicons/react/24/outline'
import { adminMenuItems } from '../../constants/adminMenuItems'
import { useAuth } from '../../contexts/AuthContext'

export default function AdminHeader({ selected }) {
  const selectedMenuItem = adminMenuItems.find((item) => item.key === selected) || {}
  const { currentUser } = useAuth()
  return (
    <header className="flex items-center justify-between h-20 px-12 border-b border-[#D9D9D9] bg-background w-full min-w-0 z-10 relative">
      <h1 className="font-inter font-bold text-[24px] leading-[38px] text-[#333]">
        {selectedMenuItem.title}
      </h1>
      <div className="flex items-center gap-3">
        <UserCircleIcon className="w-5 h-5 text-[#E47F00]" />
        <span className="font-inter text-sm sm:text-base font-medium text-foreground hidden sm:inline">
          {currentUser?.name}
        </span>
      </div>
    </header>
  )
}
